import Modal from 'bootstrap/js/dist/modal';

const FORM_MODAL_SELECTOR = '.js-form-modal';

document.querySelectorAll(FORM_MODAL_SELECTOR).forEach((modalEl) => {
    Modal.getOrCreateInstance(modalEl);
});